import {useEffect, useState} from "react";

export const useViewportSize = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const onViewportResize = () => {
			setHeight(window.innerHeight)
			setWidth(window.innerWidth);
		}
		window.addEventListener('resize', onViewportResize)
		return () => window.removeEventListener('resize', onViewportResize)
	}, [])

	return {width, height}
}